import install from "@/shared/plugins/link/linkPlugin";

export default install;